import { JobStatus } from '../../../enums/job-status.enum';
import { ShiftStatus } from '../../../interfaces/shift-status.interface';

export class ChangeCollectionStatus {
    public static readonly type = '[JobsPlacements] Change collection status';

    constructor(public id: number, public status: JobStatus, public shiftsStatuses?: Array<ShiftStatus>) { }
}
